// Abstraction to test if the DOM is present.
const canUseDOM = Boolean(
  typeof window !== 'undefined' && window.document && window.document.createElement
);

export default canUseDOM;
